import { render, staticRenderFns } from "./DialogWidget.vue?vue&type=template&id=b5012bdc"
import script from "./DialogWidget.vue?vue&type=script&lang=js"
export * from "./DialogWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports